// angular imports
import { Component, Input, OnInit } from '@angular/core';

// devextreme imports
import { formatNumber } from 'devextreme/localization';

// cc-common imports
import { IconConstants } from 'cc-common';

// model imports
import { WorkflowItemResultDto } from '../../_models/workflow-item-result-dto';

// constants imports
import { StringFormatConstants } from '../../../_constants/string-format-constants';

@Component({
    selector: 'app-workflow-invoice-line-items-viewer',
    templateUrl: './workflow-invoice-line-items-viewer.component.html',
    styleUrls: ['./workflow-invoice-line-items-viewer.component.scss']
})
export class WorkflowInvoiceLineItemsViewerComponent implements OnInit {
    @Input() lineItems: Array<WorkflowItemResultDto> = [];
    @Input() entityUsesSubCategory: boolean;

    gridItems: Array<WorkflowItemResultDto> = [];
    dimensionSource: any[] = [];

    currencyFormat: string;
    showTargetCommunity = false;

    iconPlus = IconConstants.ADD;
    iconDelete = IconConstants.DELETE;

    constructor() {
        this.customizeLineItemSummary = this.customizeLineItemSummary.bind(this);
    }

    ngOnInit() {
        this.currencyFormat = StringFormatConstants.currencyFormat;
        this.prepareLineItems();
    }

    customizeLineItemSummary(e): string {
        return 'Total: ' + formatNumber(e.value, this.currencyFormat);
    }

    private prepareLineItems(): void {
        this.dimensionSource = [];
        this.lineItems.forEach((lineItem) => {
            if (!!lineItem.targetCommunity) {
                this.showTargetCommunity = true;
            }
            if (lineItem.dimensions.length > 0) {
                lineItem.dimensions.forEach((item) => {
                    if (!this.dimensionSource.find((d) => d.dimensionCode === item.dimensionCode)) {
                        this.dimensionSource.push(item);
                    }
                    lineItem[item.dimensionCode] = item.dimensionOptionTitle;
                });
            }
        });
    }
}
